import Button from 'components/button'
import { useSession } from 'contexts/session-context'
import dayjs from 'dayjs'
import Edit from 'icons/edit'
import { Link } from 'react-router-dom'
import textServices from 'services/text-services'
import { DivProfileTitle, PProfileTitle } from 'theme/profile'
import { TextProfile, TextProfileSecondary } from 'views/profile/text.style'

const Information = () => {
  const [{ user }] = useSession()
  const name =
  user?.nickName ||
  (user?.firstName && user?.firstName.length > 20 ? user?.firstName.substring(0, 17) + '...' : user?.firstName)

  return (
    <>
      {user?.firstName && (
        <DivProfileTitle className="h-16 flex items-center px-10 w-screen">
          <PProfileTitle className="flex-grow  max-w-full">{name}</PProfileTitle>
          <Link to="/information/update">
            <Edit fill="currentColor" />
          </Link>
        </DivProfileTitle>
      )}
      <div className="font-bold text-2xl px-10 py-7 flex-1 flex flex-col break-all">
        <div className="flex-1">
          {!user?.nickName && (
            <>
              <TextProfile className="mt-3">Apodo</TextProfile>
              <TextProfileSecondary className="font-normal dinPro text-lg normal-case">
                Sin información
              </TextProfileSecondary>
            </>
          )
          }
          <TextProfile className="mt-3">Nombre y apellido</TextProfile>
          <TextProfileSecondary className="font-normal dinPro text-lg normal-case">
            {user?.firstName} {user?.lastName}
          </TextProfileSecondary>
          <TextProfile className="mt-3">Fecha de nacimiento</TextProfile>
          <TextProfileSecondary className="font-normal dinPro text-lg normal-case">{dayjs(user?.birthday).format('DD-MM-YY') || 'Sin informacion'}</TextProfileSecondary>
          {user?.email && (
            <>
              <TextProfile className="mt-3">Mail</TextProfile>
              <TextProfileSecondary className="font-normal dinPro text-lg normal-case">{user?.email}</TextProfileSecondary>
            </>
          )}
          <TextProfile className="mt-3">Género</TextProfile>
          <TextProfileSecondary className="font-normal dinPro text-lg normal-case">{user?.genre || user?.genreId || 'Sin informacion'}</TextProfileSecondary>

        </div>
        <Link to={textServices.findByText('config/prizes', '/prizes')}>
          <Button>{textServices.findByText('profile/button', 'IR A VER LOS PREMIOS')}</Button>
        </Link>
      </div>
    </>
  )
}

export default Information
